import React, { Component } from "react";
import classnames from "classnames";

import "./SelectField.css";

const hasValue = value => value !== undefined && value.length > 0;

const mergeFocused = prevState => ({ focused: true });
const mergeBlured = prevState => ({
  focused: false,
  touched: true
});

export default class Selectfield extends Component {
  state = {
    focused: false,
    touched: hasValue(this.props.value),
    floating: true
  };

  clicked = () => this.input.focus();
  focused = () => this.setState(mergeFocused);
  blured = () => this.setState(mergeBlured);

  error = () => {
    const { touched } = this.state;
    const { error } = this.props;
    return touched && error ? error : "";
  };

  changed = e => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(e.target.value);
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    var oldKeys = this.props.children.map(child => child.key).join("");
    var newKeys = nextProps.children.map(child => child.key).join("");
    return (
      newKeys !== oldKeys ||
      nextProps.value !== this.props.value ||
      nextProps.error !== this.props.error ||
      nextState !== this.state
    );
  }

  render() {
    const labelClasses = classnames("esfplus-selectfield--label", {
      "esfplus-selectfield--label__floating": this.state.floating,
      "esfplus-selectfield--label__focused": this.state.focused
    });
    const dividerClasses = classnames("esfplus-selectfield--divider", {
      "esfplus-selectfield--divider__focused": this.state.focused
    });
    const inputClasses = classnames("esfplus-selectfield--input", {
      "esfplus-selectfield--input__focused": this.state.focused
    });
    const { label, value, autoComplete, children } = this.props;
    return (
      <div className="esfplus-selectfield" onClick={this.clicked}>
        <select
          autoComplete={autoComplete}
          className={inputClasses}
          value={value}
          ref={ref => (this.input = ref)}
          onChange={this.changed}
          onFocus={this.focused}
          onBlur={this.blured}
        >
          {children}
        </select>
        <label className={labelClasses}>{label}</label>
        <div className={dividerClasses} />
        <span className="esfplus-selectfield--error">{this.error()}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/SelectField.js